export default "__VITE_ASSET__f91d6565__"